// extracted by mini-css-extract-plugin
module.exports = {"tabs":"NavBar_tabs__2zwDU","tabs__indicator":"NavBar_tabs__indicator__2kGe9","tab":"NavBar_tab__2BwBx","tab--account":"NavBar_tab--account__3Cuw5"};